module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_bufalo.dd6e59cb.jpg";